import { combineReducers } from 'redux';
import environments from './environments';
import data from './data/reducer';

const appReducer = combineReducers({
    data,
    environments: environments.getReducers()
});

export default (state, action) => {
    if (action.type === 'RESET_STORE') {
        const { data } = state;
        state = { data };
    }

    return appReducer(state, action);
};



// WEBPACK FOOTER //
// ./reducer.js